import { List, ListRow, ModalHead, Prompt, PromptBody, Title } from 'admination-react'
import type { VerbisLebenslaufFehlerZeile } from '../../api/verbisLebenslauf'

export function fehlerZeileText(f: VerbisLebenslaufFehlerZeile): string {
  const parts: string[] = []
  if (f.datei != null) parts.push(f.datei)
  if (f.seite != null) parts.push(`Seite ${f.seite}`)
  if (f.zeile != null) parts.push(`Zeile ${f.zeile}`)
  if (f.feld != null) parts.push(f.feld)
  parts.push(f.grund)
  return parts.join(' · ')
}

export function VerbisLebenslaufFehlerPrompt({
  meldung,
  fehler,
  onClose,
}: {
  meldung: string
  fehler: VerbisLebenslaufFehlerZeile[]
  onClose: () => void
}) {
  return (
    <Prompt aria-label="Nicht übernommen" onEscape={onClose} topbar={<ModalHead onClose={onClose} closeLabel="Schließen" />}>
      <PromptBody>
        <Title as="h3">Nicht übernommen</Title>
        <p>{meldung}</p>
        <List>
          {fehler.map((f, i) => (
            <ListRow key={i} title={fehlerZeileText(f)} />
          ))}
        </List>
      </PromptBody>
    </Prompt>
  )
}
